import * as React from "react";
import { Dropdown } from "react-bootstrap";
import { Eye, EllipsisVertical, Pencil, RefreshCw, Share2, Trash } from "lucide-react";
import { SavedViewListItem } from "@/hooks/saved-views";

interface SavedViewMenuProps {
    view: SavedViewListItem;
    /** When provided, shows an "Apply" item (in-dashboard panel). */
    onApply?: (view: SavedViewListItem) => void;
    onRename: (view: SavedViewListItem) => void;
    onUpdate: (view: SavedViewListItem) => void;
    /** Shows "Update with Current State"; hidden when false (home page has no live dashboard state). */
    canUpdate: boolean;
    onShare: (view: SavedViewListItem) => void;
    onRemove: (view: SavedViewListItem) => void;
}

/**
 * The `···` context menu shared by the in-dashboard and home-page saved-views
 * panels, so both expose identical actions. Uses Popper's `fixed` strategy so
 * the menu floats above any scroll container instead of being clipped.
 */
export function SavedViewMenu({ view, onApply, onRename, onUpdate, canUpdate, onShare, onRemove }: SavedViewMenuProps) {
    return (
        <Dropdown className="saved-views-panel__menu">
            <Dropdown.Toggle
                as="button"
                className="saved-views-panel__menu-toggle"
                data-test-id={`saved-view-menu-${view.ruuid}`}
            >
                <EllipsisVertical size={18} />
            </Dropdown.Toggle>
            <Dropdown.Menu align="end" renderOnMount popperConfig={{ strategy: "fixed" }}>
                {onApply && (
                    <Dropdown.Item as="button" className="d-flex align-items-center gap-2" onClick={() => onApply(view)}>
                        <Eye size={16} /> Apply
                    </Dropdown.Item>
                )}
                <Dropdown.Item as="button" className="d-flex align-items-center gap-2" onClick={() => onRename(view)}>
                    <Pencil size={16} /> Rename
                </Dropdown.Item>
                {canUpdate && (
                    <Dropdown.Item
                        as="button"
                        className="d-flex align-items-center gap-2"
                        onClick={() => onUpdate(view)}
                    >
                        <RefreshCw size={16} /> Update with Current State
                    </Dropdown.Item>
                )}
                <Dropdown.Item as="button" className="d-flex align-items-center gap-2" onClick={() => onShare(view)}>
                    <Share2 size={16} /> Share
                </Dropdown.Item>
                <Dropdown.Divider className="my-0" />
                <Dropdown.Item as="button" className="d-flex align-items-center gap-2 text-danger" onClick={() => onRemove(view)}>
                    <Trash size={16} /> Remove
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
}
